<template>
  <v-form v-model="valid">
    <v-text-field v-show="false" :model-value="item[category_field]">
    </v-text-field>
    <v-textarea
      v-model="localContent"
      hide-details
      text
      :label="quickReportLabel"
      solo
      required
      auto-grow
      rows="1"
      class="mt-2"
      @update:model-value="updateContent"
    >
      <template #prepend>
        <v-text-field v-show="false" :model-value="item[category_field]">
        </v-text-field>
        <ReportIcon :type="reportType" :icons="icons" @click="nextItem" />
      </template>
      <template #append>
        <v-btn
          class="mx-0 white--text"
          depressed
          fab
          mdi-plus
          right
          x-small
          color="green"
          :disabled="!localContent"
          @click="handleClick"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-textarea>
  </v-form>
</template>
<script>
import ReportIcon from "./ReportIcon.vue";

export default {
  name: "QuickReport",
  components: { ReportIcon },
  props: ["content_field", "category_field", "icons", "item"],
  emits: ["update:item", "click"],
  data: () => ({
    valid: true,
    localContent: "",
  }),
  computed: {
    quickReportLabel() {
      return `${this.item[this.category_field]} rapport`;
    },
    getIndex() {
      return this.item[this.category_field] || Object.keys(this.icons)[0];
    },
    reportType() {
      return this.item[this.category_field];
    },
  },
  methods: {
    handleClick() {
      if (this.localContent) {
        const updatedItem = { ...this.item };
        updatedItem[this.content_field] = this.localContent;
        this.$emit("update:item", updatedItem);
        this.$emit("click");
        this.localContent = "";
      }
    },
    nextItem() {
      let keys = Object.keys(this.icons);
      let nextIndex = keys.indexOf(this.item[this.category_field]) + 1;
      if (nextIndex >= keys.length) {
        nextIndex = 0;
      }
      const updatedItem = { ...this.item };
      updatedItem[this.category_field] = keys[nextIndex];
      this.$emit("update:item", updatedItem);
    },
    updateContent(value) {
      this.localContent = value;
    },
  },
};
</script>
